import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-the-header-navi-on-general__link__icon"
}
const _hoisted_2 = { class: "p-the-header-navi-on-general__link__arrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitChildItemObject(_ctx.paramsObject))),
    class: "p-the-header-navi-on-general__link"
  }, {
    default: _withCtx(() => [
      (_ctx.$slots.icon)
        ? (_openBlock(), _createElementBlock("i", _hoisted_1, [
            _renderSlot(_ctx.$slots, "icon")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(["p-the-header-navi-on-general__link__text", _ctx.childClassName])
      }, [
        _renderSlot(_ctx.$slots, "label")
      ], 2),
      _createElementVNode("i", _hoisted_2, [
        _createVNode(_component_IconBase, {
          width: 24,
          height: 24,
          "view-box": "0 0 24 24",
          "icon-color": "#000000"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconArrowRight)
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  })), [
    [_directive_touch, void 0, "tap"]
  ])
}